import React, { useState } from "react";
import { graphql } from 'gatsby';
import axios from "axios";
import MapStyle from "../utils/MapStyle";
import styled from "styled-components";
import addressImg from "../assets/address.svg";
import emailImg from "../assets/email.svg";
import phoneImg from "../assets/phone.svg";
import SEO from '../components/Seo';
import Layout from "../components/Layout";
import {
  Map,
  Marker,
  GoogleApiWrapper,
} from "google-maps-react";
import CircularProgress from '@material-ui/core/CircularProgress';


// Inner Components
const Container = styled.div`
  width: 80%;
  margin: 50px auto;
  @media (max-width: 768px) {
    width: 80%;
  }
`;

const Title = styled.h3`
  color: #B6936C;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 35px;
`;

const Subtitle = styled.h3`
  color: #B6936C;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 25px;
`;

const P = styled.p`
  font-weight: 12px;
  color: #707070;
`;

const Input = styled.input`
  color: #B6936C;
  background: white;
  border: 2px solid #DCC8AF;
  width: ${props => props.width ? props.width : '100%'};
  border-radius: 3px;
  padding: 8px 10px;
  margin: 8px 0;
  margin-left: ${props => props.marginLeft ? props.marginLeft : null};
  margin-right: ${props => props.marginRight ? props.marginRight : null};
`;

const Textarea = styled.textarea`
  color: #B6936C;
  background: white;
  border: 2px solid #DCC8AF;
  width: 100%;
  border-radius: 3px;
  padding: 8px 10px;
  margin: 8px 0;
`;

const Separator = styled.div`
  width: 100%;
  border: 2px solid #C1A886;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  margin-bottom: 20px;
  margin-left: 20px;
`;

const Button = styled.button`
  background-color: #C9B79F;
  border: 1px solid #C9B79F;
  border-radius: 3px;
  padding: 5px 10px;
  text-transform: uppercase;
  font-weight: bold;
  color: white;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ContactsContainer = styled.div`
  max-width: 280px;
  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 40px;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20% 0;
  @media (max-width: 768px) {
    margin: 45% 0;
  }
`;

const P2 = styled.p`
  margin: 0;
  color: ${props => props.title ? '#C9B79F' : null};
  font-size: 12px;
  font-weight: ${props => props.bold ? 'bold' : null};
  margin-top: ${props => props.title ? '10px' : null};
  margin-bottom: ${props => props.spaceBottom ? '10px' : null};
  max-width: 180px;
  text-align: center;
`;

const mapLoadingContainer = () => {
  return (
    <LoadingContainer>
      <P2 bold spaceBottom title>A carregar a Rota de Produtores</P2>
      <CircularProgress />
    </LoadingContainer>
  );
}

const ContactPage = ({
  google,
  data: {
    allStrapiContact: { nodes: contact }
  }
}) => {

  const { telephone, address, email, location } = contact[0];

  const [name, setName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submitHandler = async () => {

    if (!name || !email || !message) {
      return;
    }

    setSending(true);
    try {
      await axios.post(`${process.env.GATSBY_API_URL}/contact/send-email`, {
        name: name,
        email: emailAddress,
        message: message,
      });
      setDone(true);
    } catch (error) {
      console.log(error);
    } finally {
      setSending(false);
    }
  }

  const _mapLoaded = (mapProps, map) => {
    map.setOptions({
      styles: MapStyle
    })
  }

  return (
    <Layout>
      <SEO
        pageTitle={'Contactos'}
        description={'Página oficial da Feira do Vinho do Dão - programa, imagens e noticias ao momento'}
      />
      <div style={{ height: '50vh' }}>
        {google &&
          <Map
            containerStyle={{
              maxHeight: '600px',
              minHeight: '300px',
              height: '50vh',
            }}
            mapTypeControl={false}
            zoomControl={false}
            scaleControl={false}
            streetViewControl={false}
            google={google}
            zoom={18}
            initialCenter={{
              lat: location.latitude,
              lng: location.longitude,
            }}
            onReady={(mapProps, map) => _mapLoaded(mapProps, map)}
          >
            <Marker
              key="location-marker"
              position={{
                lat: location.latitude,
                lng: location.longitude
              }}
            />
          </Map>
        }
      </div>
      <Container>
        <InnerContainer>
          <ContactsContainer>
            <Title>Contactos</Title>
            <P><img src={addressImg} alt="address" style={{ width: '18px', height: '18px', marginRight: '10px' }} /> {address}</P>
            <P><img src={phoneImg} alt="phone" style={{ width: '18px', height: '18px', marginRight: '10px' }} /> {telephone}</P>
            <P><img src={emailImg} alt="email" style={{ width: '18px', height: '18px', marginRight: '10px' }} /> {email}</P>
          </ContactsContainer>
          {!done ? (
            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: '1', maxWidth: '400px' }}>
              <div style={{ display: 'flex' }}>
                <Subtitle>Fale connosco:</Subtitle><Separator />
              </div>
              <Input
                type="text"
                placeholder="Nome"
                onChange={(event) => setName(event.target.value)}
                value={name}
              />
              <Input
                type="text"
                placeholder="Email"
                onChange={(event) => setEmailAddress(event.target.value)}
                value={emailAddress}
              />
              <Textarea
                rows={3}
                placeholder="Mensagem"
                onChange={(event) => setMessage(event.target.value)}
                value={message}
              />
              {!sending ? <Button onClick={submitHandler}>Enviar</Button> : <CircularProgress />}
            </div>
          ) : (
              <div>
                <p>Obrigado pelo seu feedback!</p>
              </div>
            )}

        </InnerContainer>
      </Container>
    </Layout>
  );
}

export const query = graphql`
  {
    allStrapiContact {
      nodes {
        telephone
        address
        email
        location {
          latitude
          longitude
        }
      }
    }
  }
`
export default GoogleApiWrapper({
  apiKey: "AIzaSyBra_XriMSVd41OQcbU57yiSldq8M4buyo",
  LoadingContainer: mapLoadingContainer,
})(ContactPage);
